// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchBar {
    padding-bottom: 10px;
}

.pl40 {
    padding-left: 40px;
}

.mr10 {
    margin-right: 10px;
}

.noMargin {
    margin: 0px !important;
}

.settingslistbox-item {
    white-space: nowrap;
}
.nodeCheckBox {
    margin-right: 8px;
    display: flex;
}

.overwrite{
    background-color: var(--primary-color);
}`, "",{"version":3,"sources":["webpack://./src/app/settings/changelogoverview/changelog.overview.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;AACA;IACI,iBAAiB;IACjB,aAAa;AACjB;;AAEA;IACI,sCAAsC;AAC1C","sourcesContent":[".searchBar {\n    padding-bottom: 10px;\n}\n\n.pl40 {\n    padding-left: 40px;\n}\n\n.mr10 {\n    margin-right: 10px;\n}\n\n.noMargin {\n    margin: 0px !important;\n}\n\n.settingslistbox-item {\n    white-space: nowrap;\n}\n.nodeCheckBox {\n    margin-right: 8px;\n    display: flex;\n}\n\n.overwrite{\n    background-color: var(--primary-color);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
